export const isJestTest = () => {
  const isJest = import.meta.env.JEST_WORKER_ID !== undefined;
  return isJest;
};
